export default "/a5b48e0946994335e17e220415b7ad8a9ff4e295/2cb37da391587709fd85749e116baa74.svg";